import { Skeleton } from "@/app/admin/_common/ui/skeleton";
import ShowMonthNavSkeleton from "./ShowMonthNavSkeleton";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function ShowListSkeleton({ showMonthNav = true }: { showMonthNav?: boolean }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className="flex flex-col bg-card">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2.5 border-b border-border px-4 py-3 last:border-0">
            <Skeleton className="size-[42px] flex-none rounded" />
            <div className="flex min-w-0 flex-1 flex-col gap-1.5">
              <div className="flex items-center justify-between gap-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-5 w-16 rounded-[7px]" />
              </div>
              <Skeleton className="h-3 w-40" />
              <Skeleton className="h-3 w-28" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex h-full max-h-[calc(100vh-180px)] min-h-[calc(100vh-180px)] flex-1 flex-col overflow-hidden rounded-md border border-border bg-card">
      {showMonthNav && <ShowMonthNavSkeleton />}
      <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-16" />
      </div>
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="flex h-[46px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
        >
          <Skeleton className="size-7 flex-none rounded" />
          <Skeleton className="h-3 w-40" />
          <Skeleton className="ml-auto h-3 w-24" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-16" />
        </div>
      ))}
    </div>
  );
}
